/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

export const TRANSLATIONS = {
  en: {
    // Navigation Tabs
    navHome: 'Home',
    navLearn: 'Learn',
    navPlay: 'Play',
    navPrizes: 'Prizes',
    navParent: 'Parent',

    // Global Header
    playgroundLabel: '✨ PLAYGROUND:',
    addStudyMinBtn: '+1 Study Min ⏰',
    studyMinSuffix: 'm',
    changeLanguageBtn: 'Change',
    activeProfilePill: 'Avatar',

    // Language Selection Modal
    modalTitle: 'Change Language',
    modalWarning: '⚠️ Changing language will update the entire app.',
    closeBtn: 'Close',

    // General Dashboard / Header Welcome
    helloGreeting: 'Hello, {name}!',
    welcomeSub: "Let's learn something new!",
    playtimeLabel: 'Playtime:',
    starsLabel: 'Stars',
    levelLabel: 'LVL',
    explorerLabel: 'Explorer',
    minsLabel: 'Mins',
    tapToStudy: 'Tap to study!',
    seasonalSpecial: 'Seasonal Special',
    progressLabel: 'Progress',

    // Speak Greetings
    welcomeSpeakMsg: "Tap any big card to learn and play! Let's go!",
    tapStudySpeakMsg: "Tap to study!",

    // Connection Indicators & Local Storage Info
    statusOnline: 'Online',
    statusOffline: 'Offline',
    storageDescOnline: 'Connected! Your learning progress is synced and saved safely in this browser.',
    storageDescOffline: 'Offline Mode! You can still play and learn. All progress is saved locally.',
    localStoragePill: 'Local Storage Active',
  },
  ur: {
    // Navigation Tabs
    navHome: 'ہوم',
    navLearn: 'سیکھیں',
    navPlay: 'کھیلیں',
    navPrizes: 'انعامات',
    navParent: 'والدین',

    // Global Header
    playgroundLabel: '✨ پلے گراؤنڈ:',
    addStudyMinBtn: '+۱ منٹ پڑھائی ⏰',
    studyMinSuffix: ' منٹ',
    changeLanguageBtn: 'تبدیل کریں',
    activeProfilePill: 'اواتار',

    // Language Selection Modal
    modalTitle: 'زبان تبدیل کریں',
    modalWarning: '⚠️ زبان تبدیل کرنے سے پوری ایپ تبدیل ہو جائے گی۔',
    closeBtn: 'بند کریں',

    // General Dashboard / Header Welcome
    helloGreeting: 'ہیلو، {name}!',
    welcomeSub: 'آئیں کچھ نیا سیکھیں!',
    playtimeLabel: 'پڑھائی کا وقت:',
    starsLabel: 'ستارے',
    levelLabel: 'لیول',
    explorerLabel: 'ماہر',
    minsLabel: 'منٹ',
    tapToStudy: 'مطالعہ کے لیے دبائیں!',
    seasonalSpecial: 'رمضان المبارک',
    progressLabel: 'پیشرفت',

    // Speak Greetings
    welcomeSpeakMsg: 'سیکھنے اور کھیلنے کے لیے کسی بھی بڑے کارڈ پر دبائیں! چلیں شروع کریں!',
    tapStudySpeakMsg: 'مطالعہ کے لیے دبائیں!',

    // Connection Indicators & Local Storage Info
    statusOnline: 'آن لائن',
    statusOffline: 'آف لائن',
    storageDescOnline: 'آپ آن لائن ہیں! آپ کی تمام پیش رفت اسی براؤزر میں محفوظ ہو رہی ہے۔',
    storageDescOffline: 'آف لائن موڈ! آپ اب بھی کھیل اور سیکھ سکتے ہیں۔ پیش رفت مقامی طور پر محفوظ رہے گی۔',
    localStoragePill: 'لوکل سٹوریج فعال',
  },
  ar: {
    // Navigation Tabs
    navHome: 'الرئيسية',
    navLearn: 'تعلم',
    navPlay: 'ألعاب',
    navPrizes: 'الجوائز',
    navParent: 'الوالدين',

    // Global Header
    playgroundLabel: '✨ ساحة اللعب:',
    addStudyMinBtn: '+١ دقيقة دراسة ⏰',
    studyMinSuffix: ' د',
    changeLanguageBtn: 'تغيير',
    activeProfilePill: 'الصورة',

    // Language Selection Modal
    modalTitle: 'تغيير اللغة',
    modalWarning: '⚠️ تغيير اللغة سيقوم بتحديث التطبيق بالكامل.',
    closeBtn: 'إغلاق',

    // General Dashboard / Header Welcome
    helloGreeting: 'مرحباً، {name}!',
    welcomeSub: 'دعنا نتعلم شيئاً جديداً!',
    playtimeLabel: 'وقت اللعب:',
    starsLabel: 'النجوم',
    levelLabel: 'مستوى',
    explorerLabel: 'مستكشف',
    minsLabel: 'دقائق',
    tapToStudy: 'اضغط للدراسة!',
    seasonalSpecial: 'موسم خاص',
    progressLabel: 'التقدم',

    // Speak Greetings
    welcomeSpeakMsg: 'اضغط على أي بطاقة كبيرة للتعلم واللعب! هيا بنا!',
    tapStudySpeakMsg: 'اضغط للدراسة!',

    // Connection Indicators & Local Storage Info
    statusOnline: 'متصل',
    statusOffline: 'غير متصل',
    storageDescOnline: 'متصل بالإنترنت! يتم حفظ تقدمك بأمان في هذا المتصفح.',
    storageDescOffline: 'وضع غير متصل بالإنترنت! يمكنك الاستمرار في التعلم واللعب، ويتم حفظ التقدم محلياً.',
    localStoragePill: 'التخزين المحلي نشط',
  }
};

export type TranslationKey = keyof typeof TRANSLATIONS.en;
